module.exports = __webpack_public_path__ + "static/media/handshake-icon.19baddc3.svg";